import { useQuery } from "@tanstack/react-query";
import { getAtkomstStores } from "@coworker/app/src/hooks/API/core.service";
import { Store } from "../../shared/types/store";

const getAtkomstStoresWithFixaStore = async (
  hasPlatformOwnerAuthorization: boolean
) => {
  const atkomstFilteredStores = await getAtkomstStores();
  const storeWithId012 = atkomstFilteredStores.find(
    (store: Store) => store.storeId === "012"
  );

  if (!!storeWithId012 && hasPlatformOwnerAuthorization) {
    return [
      { ...storeWithId012, storeId: "012#fixa-team" },
      ...atkomstFilteredStores,
    ];
  }

  return atkomstFilteredStores;
};

export const useAtkomstCoreStores = (
  hasPlatformOwnerAuthorization: boolean,
  enabled = true
) =>
  useQuery<Store[]>({
    queryKey: ["atkomstStores", hasPlatformOwnerAuthorization],
    queryFn: () => getAtkomstStoresWithFixaStore(hasPlatformOwnerAuthorization),
    enabled,
  });
